const boxoverflown = (function ($) {
    $.fn.boxoverflown = function (options) {
        this.each(function () {
            if (
                $(this)[0].scrollHeight > $(this)[0].clientHeight ||
                $(this)[0].scrollWidth > $(this)[0].clientWidth
            ) {
                $(this).addClass("tobeScrolled");
                $(this).parent().find(".leggi-piu").addClass("visibile");
            } else {
                $(this).removeClass("tobeScrolled");
                $(this).parent().find(".leggi-piu").removeClass("visibile");
            }
        });

        $(".leggi-piu").on("click", function (e) {
            $(this).parent().find(".dooverflown").css({ maxHeight: "3000px" });
            $(this).removeClass("visibile");
            $(this).parent().find(".leggi-meno").addClass("visibile");
            //$(this).parent().find(".tobeScrolled").removeClass("dooverflown");
            $(this).parent().find(".tobeScrolled").removeClass("tobeScrolled");
        });

        $(".leggi-meno").on("click", function (e) {
            $(this).parent().find(".dooverflown").addClass("tobeScrolled");
            $(this).parent().find(".tobeScrolled").css({ maxHeight: "" });
            $(this).removeClass("visibile");
            $(this).parent().find(".leggi-piu").addClass("visibile");
            //$(this).parent().find(".tobeScrolled").addClass("dooverflown");
        });
        return this;
    };
})(jQuery);

export { boxoverflown as default };
